import axios from "axios";
import configs from "../../../../configurations/configs";

const IP = configs.SERVER_IP;

const state = {
  post_offices: [],
  physical_boxes: [],
  virtual_box: {},
  payment_response: {},
  message: "",
  status: "",
};

const getters = {
  getPhysicalBoxes: (state) => state.physical_boxes,
  getVirtualBox: (state) => state.virtual_box,
  getPostOffices: (state) => state.post_offices,
  getMessage: (state) => state.message,
  getPaymentResponse: (state) => state.payment_response,
};

const actions = {
  async createVBox({ commit }, data) {
    await axios
      .post(IP + "/client/virtual/register", data)
      .then((response) => {
        console.log(response.data);
        commit("setCreateBoxResponse", response);
      })
      .catch((error) => {
        console.log(error);
      });
  },
  async fetchPhysicalBoxes({ commit }, data) {
    await axios
      .get(IP + "/request-verification", data)
      .then((response) => {
        commit("setPhysicalBoxesResponse", response);
      })
      .catch((error) => {
        console.log(error);
      });
  },
  async fetchVirtualBox({ commit }, data) {
    await axios
      .post(IP + "/client/virtual/details", data)
      .then((response) => {
        console.log(response.data);
        commit("setVirtualBoxResponse", response);
      })
      .catch((error) => {
        console.log(error);
      });
  },
  async fetchPostOffices({ commit }) {
    await axios
      .post(IP + "/client/offices")
      .then((response) => {
        commit("setPostOfficesResponse", response);
      })
      .catch((error) => {
        console.log(error);
      });
  },
  async payForBox({ commit }) {
    await axios
      .post(IP + "/client/virtual/payment")
      .then((response) => {
        console.log(response.data);
        commit("setPaymentResponse", response);
      })
      .catch((error) => {
        console.log(error);
      });
  },
};

const mutations = {
  setCreateBoxResponse: (state, response) => {
    state.message = response.data;
  },
  setVirtualBoxResponse: (state, response) => {
    state.virtual_box = response.data;
  },
  setPhysicalBoxesResponse: (state, response) => {
    state.physical_boxes = response.data;
  },
  setPostOfficesResponse: (state, response) => {
    state.post_offices = response.data.data;
  },
  setPaymentResponse: (state, response) => {
    state.payment_response = response.data;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
